import {Component, Input, OnInit} from "@angular/core";
import {VersionDto} from "../../core/dtos/changelog/version-dto";
import {EvolutionDto} from "../../core/dtos/changelog/evolution-dto";

@Component({
  selector: 'yo-changelogs-details',
  templateUrl: './changelogs-details.component.html',
  styleUrls: ['./changelogs-details.component.scss'],
  standalone: false
})
export class ChangelogsDetailsComponent implements OnInit {

  @Input() version: VersionDto;

  splitDetailsIntoColumns(evolutions: EvolutionDto, partOfTabToReturn: number): string {
    const splitedDetails = evolutions.details.split(/ (?=\(<)/);
    if (splitedDetails[1]) {
      splitedDetails[1] = splitedDetails[1]
        .replace('(', '')
        .replace('Ticket ', '')
        .replace(')', '');
    }
    return splitedDetails[partOfTabToReturn];
  }

  ngOnInit(): void {
  }
}
